import { createSelector } from 'reselect';
import size from 'lodash/size';
import isNull from 'lodash/isNull';

export const selectClasses = state => state.classes || {};

export const selectClassesHasInitialized = state => !isNull(state.classes);

export const selectUserHasClass = createSelector([
  selectClasses,
], classes => size(classes) > 0);

